/**
 * System config API client (Phase 3 — Drive-First Pivot).
 *
 * Reads runtime configuration that drives UI behaviour:
 *   - pricing_model        ('drive_first' | 'ovacs_tiers')
 *   - annual_price_usd
 *   - trial_days / grace_period_days
 *   - stripe_publishable_key
 *   - block_uploads / block_downloads / block_viewing
 */

import { apiService } from './api'

export const systemConfigAPI = {
  get: () => apiService.get('/system/config/'),
}

export default systemConfigAPI
